export { SegmentedControl, type SegmentedControlItemInput } from "./segmented-control";
